module.exports = __webpack_public_path__ + "files/cf2d144badbd88e4b91008320d89c380.png";